import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import LockIcon from '@atlaskit/icon/core/lock-locked';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import {
	type SearchResultEntity,
	type SearchResultGraphDocument,
} from '@atlassian/dynamic-cards-search-client';

import { messages } from './messages';

const iconColor = token('color.icon');
interface RestrictedLozengeProps {
	permissionLevel: SearchResultGraphDocument<SearchResultEntity>['permissionLevel'];
}

export const LOZENGE_TEST_ID = 'restricted-lozenge';

export const RestrictedIcon = ({ permissionLevel }: RestrictedLozengeProps): React.JSX.Element => {
	const tooltipText =
		permissionLevel === 'private' ? messages.privateTooltip : messages.restrictedTooltip;

	return (
		<Tooltip content={<FormattedMessage {...tooltipText} />}>
			<Box testId={LOZENGE_TEST_ID}>
				<LockIcon label="" color={iconColor} size="small" />
			</Box>
		</Tooltip>
	);
};
